  <template >
   <div class="formPosition" v-role="roles">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col >
         <span>Cadastrar nova Turma - Escolhe a classe </span>

                 <v-icon large color="green darken-2">forward</v-icon>

<div class="text-center">

    <v-btn @click="classe(1)" class="ma-2" outlined color="indigo"><v-icon  small color="primary" >filter_1</v-icon> 10ª classe</v-btn>
    <v-btn @click="classe(2)" class="ma-2" outlined color="indigo"><v-icon  small  color="primary" >filter_2</v-icon> 11ª classe</v-btn>
    <v-btn @click="classe(3)" class="ma-2" outlined color="indigo"><v-icon  small  color="primary" >filter_3</v-icon> 12ª classe</v-btn>
    <v-btn @click="classe(4)"
     class="ma-2" outlined color="indigo"><v-icon  small  color="primary" >filter_4</v-icon> 13ª classe</v-btn>
  </div>
      </v-col>
      <v-col md="2">
             <v-select
              :items="Listaranoslectivo"
              v-model="anolectivoSelected"
              item-value="descricao"
              item-text="descricao"
              @change="FiltraAnolectivo()"
              label="Selecione o Ano lectivo"
            ></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {

  data: () => ({
    anolectivoSelected: ls.get('anolectivo'),
    Listaranoslectivo: [],
    roles: 'func'
  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },

  created () {
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    this.initializeAnosLectivo()
    // Seta o anolectivo padrão
    this.$store.state.anolectivoSelecionado = this.anolectivoSelected
  },

  methods: {
    classe (idclasse) {
      const ls = require('local-storage')
      this.$store.state.idclasse = idclasse
      if (idclasse === 1) {
        this.$store.state.classeTur = '10ªC-' + ls.get('anolectivo')
      } else if (idclasse === 2) {
        this.$store.state.classeTur = '11ªC-' + ls.get('anolectivo')
      } else if (idclasse === 3) {
        this.$store.state.classeTur = '12ªC-' + ls.get('anolectivo')
      } else if (idclasse === 4) {
        this.$store.state.classeTur = '13ªC-' + ls.get('anolectivo')
      }
      this.$router.push('Turmacrud_MudarTurma')

      //  this.$store.dispatch('setidclasse', idclasse)
    },

    async initializeAnosLectivo () {
      try {
        this.Listaranoslectivo = await axios
          .get('/listarAnoLectivoAll2')
          .then(res => res.data)
      } catch (error) {
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
      }
    },

    FiltraAnolectivo () {
      this.$store.state.anolectivoSelecionado = this.anolectivoSelected
    }
  }
}
</script>
